import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Grid, Breadcrumb, Button, ButtonToolbar, Row, Col, Panel } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { ROOT_URL, ROOT_API_URL } from '../../actions/root_url';
import { roundTo } from '../Common/NumberUtil';
import {useState} from "react"

class PriceAdjustmentDetail extends Component {
  static contextTypes = {
      router: React.PropTypes.object
  };
  constructor() {
    super();
    this.state = {
      purchase: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      print: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      isToday: true,
    }
    this.deleteLine = this.deleteLine.bind(this);
  }

  /*componentWillMount() {
  }
  componentWillReceiveProps(nextProps) {
    if(nextProps.priceAdjustment && nextProps.priceAdjustment != this.props.priceAdjustment) {
      let purchase = {...this.state.purchase, rows: nextProps.priceAdjustment.Line}
      let lines = nextProps.priceAdjustment.Line;
      if(lines) {
        lines.map((r) => {
          if(r.UpdatePrice) {
            r.show = true;
          }
          else {
            r.show = false;
          }
        })
        let print = {...this.state.print, rows: lines}
        let date = nextProps.priceAdjustment.Date;


        let today = new Date();
        let y = today.getFullYear().toString();
        let m = today.getMonth()+1;
        //let m = today.getDay()+1;
        if(m < 10) {
          m = '0'+m;
        }
        else {
          m = m.toString();
        }
        let d = today.getDate();
        if(d < 10) {
          d = '0'+d;
        }
        else {
          d = d.toString();
        }
        d = y + m + d;

        let isToday = true;
        if(date < d) {
          isToday = false;
        }
        this.setState({purchase, print, isToday})
      }
    }
  }*/

  componentWillMount() {
  }
  componentWillReceiveProps(nextProps) {
    if(nextProps.priceAdjustment && nextProps.priceAdjustment != this.props.priceAdjustment) {
      let purchase = {...this.state.purchase, rows: nextProps.priceAdjustment}
      let lines = nextProps.priceAdjustment;
      if(lines) {
        lines.map((r) => {
          if(r.UpdatePrice) {
            r.show = true;
          }
          else {
            r.show = false;
          }
        })
        let print = {...this.state.print, rows: lines}

        

        let today = new Date();
        let y = today.getFullYear().toString();
        let m = today.getMonth()+1;
        //let m = today.getDay()+1;
        if(m < 10) {
          m = '0'+m;
        }
        else {
          m = m.toString();
        }
        let d = today.getDate();
        if(d < 10) {
          d = '0'+d;
        }
        else {
          d = d.toString();
        }
        d = y + m + d;

        let isToday = true;
        
        this.setState({purchase, print, isToday})
      }
    } else {
      componentWillReceiveProps(nextProps) 
        if(nextProps.priceAdjustment && nextProps.priceAdjustment != this.props.priceAdjustment) {
          let purchase = {...this.state.purchase, rows: nextProps.priceAdjustment.Line}
          let lines = nextProps.priceAdjustment.Line;
          if(lines) {
            lines.map((r) => {
              if(r.UpdatePrice) {
                r.show = true;
              }
              else {
                r.show = false;
              }
            })
            let print = {...this.state.print, rows: lines}
            let date = nextProps.priceAdjustment.Date;
    
    
            let today = new Date();
            let y = today.getFullYear().toString();
            let m = today.getMonth()+1;
            //let m = today.getDay()+1;
            if(m < 10) {
              m = '0'+m;
            }
            else {
              m = m.toString();
            }
            let d = today.getDate();
            if(d < 10) {
              d = '0'+d;
            }
            else {
              d = d.toString();
            }
            d = y + m + d;
    
            let isToday = true;
            if(date < d) {
              isToday = false;
            }
            this.setState({purchase, print, isToday})
          }
        }
      }
    }

  handleFormSubmit() {
    this.props.createPriceAdjustment(this.state.purchase.rows)
  }
  deleteLine(WarehouseReceiveLine_id) {
    let print = {...this.state.print};
    print.rows.map(r => {
      if(r.WarehouseReceiveLine_id == WarehouseReceiveLine_id) {
        r.show = false;
      }
    })
    this.setState({print});
  }
  renderPurchaseTable() {
    if (this.props.purchasingPerformanceIsLoading && !this.props.purchasingPerformanceError) return (
      <div id="spinner">
        <Spinner/>
      </div>
    )
    else if (this.props.purchasingPerformanceError) return (
     <ContentWrapper>
       <div className="alert alert-danger">{JSON.stringify(this.props.purchasingPerformanceError)}</div>
     </ContentWrapper>
    )
    else {
        // Parameters of the react-data-grid

        const getRows = () => {
            return Data.Selectors.getRows(this.state.purchase);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return Object.assign({Idx: rowIdx}, rows[rowIdx]);
        }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var purchase = Object.assign({}, this.state.purchase, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState({purchase});
        }

        const handleRowUpdated = e => {
          let rows = getRows();
          Object.assign(rows[e.rowIdx], e.updated);
          // let print = {...this.state.print, rows: rows};
          // print.rows.map(r => {
          //   if(r.WarehouseReceiveLine_id == rows[e.rowIdx].WarehouseReceiveLine_id) {
          //     r.show = true;
          //     r.Action = null;
          //   }
          // })

          if (e.cellKey === 'UpdatePrice') {
            rows[e.rowIdx].UpdatePrice = +parseFloat(roundTo(rows[e.rowIdx].UpdatePrice, 2)).toFixed(2);
          }
          const purchase = { ...this.state.purchase, rows };
          this.setState({ purchase });
        }

        //Custom Formatter component

        const DateFormatter = React.createClass({
            render() {
                if (this.props.value) {
                  let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                  let date = new Date(this.props.value)
                  let index = dateMap.indexOf(date.toString().slice(4,3));
                  let localDate = index + date.toString().slice(8, 6);
                  return <span>{date.toString().slice(4, 15)}</span>;;
                }
                else return <span className="label label-danger">-</span>;
            }
        });

        const ReceivePriceFormatter = React.createClass({
          render() {
            if(this.props.dependentValues.LastPrice < this.props.value)
              return <span style={{color: "red"}}>{this.props.value}</span>
            else
              return <span>{this.props.value}</span>
          }
        })

        const handleActionClick = (action, type) => {
          let purchase = {...this.state.purchase};
          purchase.rows[action.dependentValues.Idx].Action = type;
          if(type == "Match") {
            purchase.rows[action.dependentValues.Idx].UpdatePrice = purchase.rows[action.dependentValues.Idx].RcvUnitPrice;
          }
          else {
            purchase.rows[action.dependentValues.Idx].UpdatePrice = null;
          }
          let print = {...this.state.print, rows: purchase.rows};
          if(type === "Match" || type === 'Update') {
            print.rows.map(r => {
              if(r.WarehouseReceiveLine_id == purchase.rows[action.dependentValues.Idx].WarehouseReceiveLine_id) {
                r.show = true;
              }
              // else {
              //   r.show = false;
              // }
            })
          }
          else {
            print.rows.map(r => {
              if(r.WarehouseReceiveLine_id == purchase.rows[action.dependentValues.Idx].WarehouseReceiveLine_id) {
                r.show = false;
              }
              // else {
              //   r.show = false;
              // }
            })
          }
          purchase.rows[action.dependentValues.Idx].EffectNow = false;
          this.setState({purchase, print});
        }

        const handleEffectNowClick = (effectNow) => {
          let purchase = {...this.state.purchase};
          purchase.rows[effectNow.dependentValues.Idx].EffectNow = !(purchase.rows[effectNow.dependentValues.Idx].EffectNow);
          this.setState({purchase});
        }

        const ActionFormatter = React.createClass({
            render() {
              const { Status } = this.props.dependentValues;
              const shouldDisable = Status === 'Done' || Status === 'Void';
              return (
                <div>
                  <label>
                    <input type="radio" value="Pass"
                      checked={this.props.value === "Pass"}
                      onClick={()=> {handleActionClick(this.props, "Pass")}}
                      disabled={shouldDisable}
                    />
                    <Translate value="pass" />
                  </label>
                  <label>
                    <input type="radio" value="Match"
                      checked={this.props.value === "Match"}
                      onClick={()=> {handleActionClick(this.props, "Match")}}
                      disabled={shouldDisable}
                    />
                    <span><Translate value="match" /></span>
                  </label>
                  <label>
                    <input type="radio" value="Update"
                      checked={this.props.value === "Update"}
                      onClick={()=> {handleActionClick(this.props, "Update")}}
                      disabled={shouldDisable}
                    />
                    <span><Translate value="update" /></span>
                  </label>
                </div>
              )
            }
        })

        const EffectNowFormatter = React.createClass({
          render() {
            const { Action, Status } = this.props.dependentValues;
            const value = (this.props.value) ? "Now" : "Tomorrow"
            return (
              <div>
                <input
                  type="checkbox"
                  value="true"
                  checked={this.props.value == true || this.props.value == "true"}
                  onClick={()=>{handleEffectNowClick(this.props)}}
                  disabled={(Action !== 'Update' && Action !== 'Match') || Status === 'Done' || Status === 'Void'}
                />
                <span>{ value }</span>
              </div>
            )
          }
        })
         const VitDateFormatter = React.createClass({
           render() {
             if (this.props.value) {
               const Vitdate = (this.props.value).split("_")[0] + "  " + ((this.props.value).split("_")[1] + ":00")
               return <span>{Vitdate}</span>;
             }
           },
         });
        
        const AppointmentFormatter = React.createClass({
          render() {
            if (this.props.value.online = '0')
              return <span>{online}</span>;
            else return <span>{Onsite}</span>;
          }
        });  
        

        const printLineFormatter = React.createClass({
          render() {
            let url = this.props.dependentValues && (ROOT_URL + 'v1/warehouse/printbarcode/' + this.props.dependentValues.ProductNum + "?Bearer=" + localStorage.getItem('token'));
            return <span>
                    <Button
                      bsStyle="primary"
                      className="textAlignStyle"
                      style={{ height: '23px', width: '39px', padding: '0px' }}
                      href={url}
                    >
                        <Translate value="print" />
                    </Button>
                  </span>;
          }
        })
        // Column difinition

        let columns = [
          {
              key: 'ReceiveDate',
              name: <Translate value="receive_date" />,
              resizable: true,
              sortable: true,
              width: 85,
              //formatter: DateFormatter
          },
          {
              key: 'WarehouseReceiveNum',
              name: <Translate value="receive_num" />,
              resizable: true,
              sortable: true,
              width: 105,
          },
          {
              key: 'ProductNum',
              name: <Translate value="prod_num" />,
              resizable: true,
              sortable: true,
              width: 75,
          },
          {
              key: 'ProductName',
              name: <Translate value="prod_name" />,
              resizable: true,
              sortable: true,
              width: 220,
          },
          {
              key: 'ProductDescription',
              name: <Translate value="desc" />,
              resizable: true,
              sortable: true,
              width: 110,
          },
          {
              key: 'LastPrice',
              name: <Translate value="last_dollarsign" />,
              resizable: true,
              sortable: true,
              width: 65,
          },
          {
              key: 'ProductRefPrice',
              name: <Translate value="ref_dollarsign" />,
              resizable: true,
              sortable: true,
              width: 65,
          },
          {
              key: 'RcvUnitPrice',
              name: <Translate value="receive_dollarsign" />,
              resizable: true,
              sortable: true,
              width: 75,
              formatter: ReceivePriceFormatter,
              getRowMetaData: (row) => row,
          },
          {
              key: 'Status',
              name: <Translate value="status" />,
              resizable: true,
              width: 70,
          },
          {
              key: 'Action',
              name: <Translate value="action" />,
              resizable: true,
              width: 210,
              formatter: ActionFormatter,
              getRowMetaData: (row) => row,
          },
          {
              key: 'UpdatePrice',
              name: <Translate value="update_dollarsign" />,
              resizable: true,
              sortable: true,
              width: 75,
              editable: row => row.Action === 'Update' && row.Status !== 'Done' && row.Status !== 'Void',
              getRowMetaData: row => row,
          },
          {
              key: 'EffectNow',
              name: <Translate value="effect" />,
              resizable: true,
              sortable: true,
              width: 90,
              formatter: EffectNowFormatter,
              getRowMetaData: (row) => row
          },
          {
              key: 'Print',
              name: <Translate value="print_label" />,
              formatter: printLineFormatter,
              resizable: true,
              sortable: true,
              width: 60,
              getRowMetaData: (row) => row
          },
          {
              key: 'Modifier_User_Name',
              name: <Translate value="modifier" />,
              resizable: true,
              sortable: true,
              width: 100,
          },
          ];
          
        return (
          <Row>
            <Col sm={ 12 }>
              <div className="react-table-price-adjustment-purchase" id="PriceAdjustmentDetail-dataGrid1">
                <ReactDataGrid
                    enableCellSelect={true}
                    onGridSort={handleGridSort}
                    columns={columns}
                    headerRowHeight={45}
                    minHeight={650}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    onRowUpdated={handleRowUpdated}
                  />
              </div>
            </Col>
          </Row>
        )
    }
  }
  renderPrintTable() {
    const deleteLine = this.deleteLine;
    if (this.props.purchasingPerformanceIsLoading && !this.props.purchasingPerformanceError) return (
      <div id="spinner">
        <Spinner/>
      </div>
    )
    else if (this.props.purchasingPerformanceError) return (
     <ContentWrapper>
       <div className="alert alert-danger">{JSON.stringify(this.props.purchasingPerformanceError)}</div>
     </ContentWrapper>
    )
    else {
        // Parameters of the react-data-grid

        const getRows = () => {
            let print = this.state.print;
            print.rows = print.rows.filter(r => {
              return r.show;
            })
            return Data.Selectors.getRows(this.state.print);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var print = Object.assign({}, this.state.print, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState({print});
        }

        //Custom Formatter component

        const DateFormatter = React.createClass({
            render() {
                if (this.props.value) {
                  let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                  let date = new Date(this.props.value)
                  let index = dateMap.indexOf(date.toString().slice(4,3));
                  let localDate = index + date.toString().slice(8, 6);
                  return <span>{date.toString().slice(4, 15)}</span>;;
                }
                else return <span className="label label-danger">-</span>;
            }
        });

        const IsVariableFormatter = React.createClass({
            render() {
              return <span>
                      <Button
                        bsStyle="danger"
                        className="textAlignStyle"
                        style={{ height: '23px', width: '39px', padding: '0px' }}
                        onClick={ () => {
                          deleteLine(this.props.dependentValues.WarehouseReceiveLine_id);
                        } }
                      >
                          <Translate value="X" />
                      </Button>
                    </span>;
            }
        });

        const printLineFormatter = React.createClass({
          render() {
            let url = this.props.dependentValues && (ROOT_URL + 'v1/warehouse/printbarcode/' + this.props.dependentValues.ProductNum + "?Bearer=" + localStorage.getItem('token'));
            return <span>
                    <Button
                      bsStyle="primary"
                      className="textAlignStyle"
                      style={{ height: '23px', width: '39px', padding: '0px' }}
                      href={url}
                    >
                        <Translate value="print" />
                    </Button>
                  </span>;
          }
        })

        const EffectFormatter = React.createClass({
          render() {
            let value = (this.props.value) ? "Now":"Tomorrow"
            return (
              <span>{ value }</span>
            )
          }
        })

        // Column difinition

        const columns = [
          {
              key: 'Delete',
              name: <Translate value="del" />,
              formatter: IsVariableFormatter,
              width: 50,
              getRowMetaData: (row) => row
          },
          {
              key: 'ProductNum',
              name: <Translate value="prod_num" />,
              resizable: true,
              sortable: true,
              width: 90,
          },
          {
              key: 'Print',
              name: <Translate value="print" />,
              formatter: printLineFormatter,
              resizable: true,
              sortable: true,
              width: 50,
              getRowMetaData: (row) => row
          },
          {
              key: 'EffectNow',
              name: <Translate value="effect" />,
              resizable: true,
              sortable: true,
              width: 90,
              formatter: EffectFormatter
          },
        ]

        return (
          <Row>
            <Col sm={ 12 }>
              <div className="react-table-price-adjustment-print"  id="PriceAdjustmentDetail-dataGrid2">
                <ReactDataGrid
                    enableCellSelect={true}
                    onGridSort={handleGridSort}
                    columns={columns}
                    minHeight={650}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize() }
                  />
              </div>
            </Col>
          </Row>
        )
    }
  }
  render() {
    const { handleSubmit } = this.props;
    // let print_url = null;
    // let excel_url = null;
    // if(this.props.priceAdjustment) {
    //   print_url = ROOT_URL + 'v1/warehouse/receiveprice/print/' + this.props.priceAdjustment.Date + "?Bearer=" + localStorage.getItem('token');
    //   excel_url = ROOT_URL + 'v1/warehouse/receiveprice/excel/' + this.props.priceAdjustment.Date + "?Bearer=" + localStorage.getItem('token');
    // }
    let date = this.props.priceAdjustment && this.props.priceAdjustment.Date;
    date = date && `${date.slice(4, 6)} / ${date.slice(6)} / ${date.slice(0, 4)}`;
    return (
      <ContentWrapper>
        <ButtonToolbar>
          <Button
            bsStyle="success"
            type="button"
            disabled={!(this.state.isToday)}
            onClick={this.handleFormSubmit.bind(this)}
          >
            <em className="fa fa-save" />
            <Translate value="save" />
          </Button>
          <Button bsStyle="danger" onClick={ () => { this.context.router.push('/priceAdjustmentReport') } }>
            <em className="fa fa-close"/>
            <Translate value="cancel" />
          </Button>
          {/* <Button bsStyle="primary" href={print_url}>
            <Translate value="print" />
          </Button>
          <Button bsStyle="primary" href={excel_url}>
            <Translate value="excel" />
          </Button> */}
        </ButtonToolbar>
        <Grid fluid="true" id="price-adjustment-page">
          <form autoComplete="off" method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } >
            <h3>
              {date}
            </h3>
            <Row>
              <Col md={12}>
                <Panel className="position-relative table-collapse-fix">
                  {this.renderPurchaseTable()}
                </Panel>
              </Col>
              {/* <Col md={ 3 }>
                <Panel className="position-relative table-collapse-fix">
                  {this.renderPrintTable()}
                </Panel>
              </Col> */}
            </Row>
          </form>
        </Grid>
      </ContentWrapper>
    );
  }
}

export default PriceAdjustmentDetail;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/priceAdjustmentDetail.jsx